import { AxiosResponse } from 'axios';

export interface BulkService {
  getMoveClassDestinations: (organizationId: string) => Promise<MoveDestinationsResponse>;
  moveStudents: (
    organizationId: string,
    studentIds: string[],
    destinationGroupId: string
  ) => Promise<MoveStudentsResponse>;
  bulkDeleteGroups: (
    organizationId: string,
    payload: BulkDeleteGroupsRequest
  ) => Promise<BulkDeleteGroupsResponse>;
  getBulkOperation: (organizationId: string, operationId: string) => Promise<BulkOperationResponse>;
  deleteStudents: (
    organizationId: string,
    studentIds: string[],
    reason: string
  ) => Promise<DeleteStudentsResponse>;
  changeStudentsLevel: (
    organizationId: string,
    studentIds: string[],
    newLevel: string
  ) => Promise<ChangeStudentsLevelResponse>;
}

export type BulkDeleteGroupsRequest = {
  groupIds: string[];
  reason: string;
};

export type BulkDeleteGroupsResponseData = {
  operationId?: string;
};

export type BulkDeleteGroupsResponse = AxiosResponse<{
  message: string;
  status: string;
  data: BulkDeleteGroupsResponseData;
}>;

export type MoveClassDestination = {
  groupId: string;
  groupName: string;
  gradeId: number;
  currentStudentCount: number;
  remainingCapacity: number;
  teacherNames: string[];
};

export type MoveClassDestinationResponseData = {
  classes: MoveClassDestination[];
};

export type MoveDestinationsResponse = AxiosResponse<{
  message: string;
  status: string;
  data: MoveClassDestinationResponseData;
}>;

export type MoveStudentsResponseData = {
  operationId?: string;
  status?: string;
  totalRequested: number;
  gradeMismatchDetected: boolean;
  gradeMismatchStudentIds?: string[];
};

export type MoveStudentsResponse = AxiosResponse<{
  message: string;
  status: string;
  data: MoveStudentsResponseData;
}>;

export type BaseBulkOperationItem = {
  itemId: string;
  itemName?: string;
  success: boolean;
  failureReason?: string;
};

export type MoveStudentsBulkOperationItem = {
  studentId: string;
  studentName?: string;
  success: boolean;
  error?: string;
};

export type DeleteStudentsBulkOperationItem = {
  studentId: string;
  studentName?: string;
  success: boolean;
  error?: string;
};

export type ChangeStudentsLevelBulkOperationItem = {
  studentId: string;
  studentName?: string;
  success: boolean;
  error?: string;
};

export type BulkOperationItem =
  | BaseBulkOperationItem
  | MoveStudentsBulkOperationItem
  | DeleteStudentsBulkOperationItem
  | ChangeStudentsLevelBulkOperationItem;

export enum BulkOperationState {
  Pending = 'pending',
  InProgress = 'in_progress',
  Completed = 'completed',
  PartialSuccess = 'partial_success',
  Failed = 'failed',
}

export type BulkOperationResponseData = {
  operationId: string;
  state: BulkOperationState;
  totalItems: number;
  completedItems: number;
  failedItems: number;
  results: BulkOperationItem[];
};

export type BulkOperationResponse = AxiosResponse<{
  message: string;
  status: string;
  data: BulkOperationResponseData;
}>;

export type DeleteStudentsResponseData = {
  operationId?: string;
  status?: string;
  totalRequested: number;
};

export type DeleteStudentsResponse = AxiosResponse<{
  message: string;
  status: string;
  data: DeleteStudentsResponseData;
}>;

export type ChangeStudentsLevelResponseData = {
  operationId?: string;
  status?: string;
  totalRequested: number;
};

export type ChangeStudentsLevelResponse = AxiosResponse<{
  message: string;
  status: string;
  data: ChangeStudentsLevelResponseData;
}>;
